// Ref: https://github.com/broadlume/BroadlumeX-Catalog/blob/682abb12f7882546019f7f82098d91cfeba9d403/backend/lib/common/CicFieldMapper.ts#L902
export const cicAttributeMap: Record<string, string> = {
  usageContexts: 'classification.characteristics.usageContexts',
  backingMaterial: 'descriptions.others.backingMaterial',
  constructionMethod: 'classification.characteristics.constructionMethod',
  certifications: 'descriptions.others.certifications',

  colorFamily: 'classification.characteristics.colorFamily',
  colorTone: 'classification.characteristics.colorTone',
  colorVariation: 'classification.characteristics.colorVariation',

  residentialWarranty: 'descriptions.others.residentialWarranty',
  commercialWarranty: 'descriptions.others.commercialWarranty',

  coreMaterial: 'descriptions.others.coreMaterial',
  edgeProfile: 'classification.characteristics.edgeProfile',
  endProfile: 'classification.characteristics.endProfile',

  fiberContent: 'descriptions.others.fibreContentName',
  fiberGroup: 'classification.characteristics.fiberGroup',
  fiberBrand: 'descriptions.others.fibreBrand',

  glossLevel: 'classification.characteristics.glossLevel',

  installationGrades: 'classification.characteristics.installationGrades',
  installationTypes: 'classification.characteristics.installationTypes',

  lightSensitivity: 'classification.characteristics.lightSensitivity',
  fadeResistant: 'classification.characteristics.fadeResistant',
  ecoFriendly: 'classification.characteristics.ecoFriendly',
  petFriendly: 'classification.characteristics.petFriendly',

  vocLevel: 'classification.characteristics.vocLevel',
  stainResistanceRating: 'classification.characteristics.stainResistanceRating',
  antimicrobial: 'classification.characteristics.antiMicrobial',
  abrasionCriteriaRating:
    'classification.characteristics.abrasionCriteriaRating',

  look: 'classification.characteristics.look',
  woodSpecies: 'classification.characteristics.woodSpecies',

  material: 'classification.characteristics.material',

  patternMatchWidth: 'dimensions.others.patternMatchWidth.value',
  patternMatchDepth: 'dimensions.others.patternMatchDepth.value',
  patternMatchType: 'classification.characteristics.patternMatchType',
  patternType: 'classification.characteristics.patternType',

  shape: 'classification.characteristics.shape',
  finish: 'classification.characteristics.finish',

  waterProtection: 'classification.characteristics.waterProtection',
  waterAbsorption: 'classification.characteristics.waterAbsorption',

  breakingStrength: 'classification.characteristics.breakingStrength',
  scratchHardness: 'classification.characteristics.scratchHardness',

  wearLayerThickness: 'classification.characteristics.wearLayerThickness',
  wearLayerMaterial: 'descriptions.others.wearLayerMaterial',

  applications: 'classification.characteristics.applications',

  faceCutType: 'classification.characteristics.faceCutType',
  jankaRating: 'classification.characteristics.jankaRating',
  strainTreatment: 'descriptions.others.strainTreatment',

  styleNumber: 'refCodes.others.styleNumber',
  colorNumber: 'refCodes.others.colorNumber',
  facesRepeat: 'classification.characteristics.facesRepeat',

  lockingSystem: 'descriptions.others.lockingSystem',

  builtInUnderlayment: 'classification.characteristics.builtInUnderlayment',
  underlaymentType: 'descriptions.others.underlaymentType',

  durabilityRating: 'classification.characteristics.durabilityRating',
  radiantHeatApproved: 'classification.characteristics.radiantHeatApproved',
  ecoQualifier: 'descriptions.others.ecoQualifier',

  piecesPerCarton: 'classification.characteristics.piecesPerCarton',
  cartonsPerPallet: 'classification.characteristics.cartonsPerPallet',
  coveragePerCarton: 'classification.characteristics.coveragePerCarton',
  coveragePerPallet: 'classification.characteristics.coveragePerPallet',

  weightPerPack: 'dimensions.others.weightPerPack.value',

  faceWeightPerArea: 'classification.characteristics.faceWeightPerArea',
  density: 'classification.characteristics.density',
  carpetTwist: 'classification.characteristics.carpetTwist',
  pileHeight: 'classification.characteristics.pileHeight',
  dyeMethod: 'descriptions.others.dyeMethod',

  mosaicDepth: 'dimensions.others.mosaicDepth.value',
  mosaicWidth: 'dimensions.others.mosaicWidth.value',

  hardnessPEI: 'classification.characteristics.hardnessPEI',
  frictionCoefficientWet:
    'classification.characteristics.frictionCoefficientWet',
  frictionCoefficientDry:
    'classification.characteristics.frictionCoefficientDry',
  dynamicFrictionCoefficientRating:
    'classification.characteristics.dynamicFrictionCoefficientRating',
};
